export const FAQS = [
  {
    q: "Is BRep a subscription?",
    a: "No. BRep is pay-per-service. Buy the help you need, when you need it. No monthly commitments, no recurring charges.",
  },
  {
    q: "How do I know the coaches are qualified?",
    a: "Every BRep coach is checked before being approved to provide services through the platform.",
  },
  {
    q: "How do I get started?",
    a: "Browse the Services page, pick what fits your goal, and book through the BRep app. Not sure where to begin? Start with a Coach Consultation to figure out the right service for you.",
  },
  {
    q: "How does a Lift Review work?",
    a: "You upload a video of your lift. A qualified coach reviews it and sends back a written breakdown plus a marked-up video with clear cues — usually within 24–48h.",
  },
  {
    q: "What if I don't know which service I need?",
    a: "Start with a Coach Consultation. It's a short call where a coach helps you diagnose what will move the needle for you, then you can pick the right service.",
  },
  {
    q: "Do you refund if I'm not happy?",
    a: "Yes — if a service hasn't started and you change your mind, you get a refund. Once a coach has begun work, we assess case by case and always err on the side of the client.",
  },
  {
    q: "How do I apply as a coach?",
    a: "Head to the For Coaches page or the Contact page and tell us about your credentials and experience. Our team reviews every application and will be in touch about next steps.",
  },
  {
    q: "Where are you based?",
    a: "BRep is powered by Byron Performance Coaching, based in the UK, working with clients worldwide.",
  },
];
